import ProfileBgAnimation from "../ProfileBgAnimation";
import Typewriter from "typewriter-effect";
import { Bio } from "../../data/constants";
import {
  Img,
  ProfileBg,
  ProfileContainer,
  ProfileInnerContainer,
  ProfileLeftContainer,
  ProfileRightContainer,
  Span,
  SubTitle,
  TextLoop,
  Title,
} from "./ProfileSectionStyles";
import { SocialMediaIcon, SocialMediaIcons } from "./ProfileSectionStyles";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";

const ProfileSection = () => {
  return (
    <div id="about">
      <ProfileContainer>
        <ProfileBg>
          <ProfileBgAnimation />
        </ProfileBg>
        <ProfileInnerContainer>
          <ProfileLeftContainer id="Left">
            <Title>
              Hi, I am <br /> {Bio.name} <span className="wave">👋</span>
            </Title>
            <TextLoop>
              I'm a
              <Span>
                <Typewriter
                  options={{
                    strings: Bio.roles,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>
            <SubTitle>{Bio.description}</SubTitle>
            <SocialMediaIcons>
              <SocialMediaIcon href={Bio.linkedin} target="display">
                <LinkedInIcon />
              </SocialMediaIcon>
              <SocialMediaIcon href={Bio.insta} target="display">
                <InstagramIcon />
              </SocialMediaIcon>
              <SocialMediaIcon href={Bio.facebook} target="display">
                <FacebookIcon />
              </SocialMediaIcon>
            </SocialMediaIcons>
          </ProfileLeftContainer>

          <ProfileRightContainer id="Right">
            <Img src={"/images/me_profile1.jpeg"} alt="Mannat Saluja" />
          </ProfileRightContainer>
        </ProfileInnerContainer>
      </ProfileContainer>
    </div>
  );
};

export default ProfileSection;
